module.exports = __webpack_public_path__ + "static/lux-fcce813b7e9a895e90296175bf7bdb09.jpg";